<template>
  <div v-if="shouldShow" class="language-toggle">
    <button
      class="language-button"
      :class="{ active: currentLocale === leftLang }"
      type="button"
      :aria-pressed="currentLocale === leftLang"
      @click="setLocale(leftLang)"
    >
      {{ getLocaleLabel(leftLang) }}
    </button>

    <button
      class="language-button"
      :class="{ active: currentLocale === rightLang }"
      type="button"
      :aria-pressed="currentLocale === rightLang"
      @click="setLocale(rightLang)"
    >
      {{ getLocaleLabel(rightLang) }}
    </button>
  </div>
</template>

<script>
import store from "@/utils/store";

export default {
  name: "LanguageToggle",
  data() {
    return {
      country: store.currentCountry,
      currentLocale: store.currentLocale,
      // 言語ラベル
      languageLabels: {
        ja: "中",
        en: "En",
        ko: "韓",
        "zh-TW": "中",
        "zh-HK": "中",
      },
      // 国ごとの設定
      countryConfigs: {
        hk: {
          show: true,
          leftLang: "zh-HK",
          rightLang: "en",
        },
        tw: {
          show: false,
          leftLang: "zh-TW",
          rightLang: "en",
        },
        ko: {
          show: false,
          leftLang: "ko",
          rightLang: "en",
        },
        ja: {
          show: false,
          leftLang: "ja",
          rightLang: "en",
        },
      },
    };
  },
  computed: {
    // 現在の国設定を取得
    config() {
      return this.countryConfigs[this.country] || { show: false };
    },
    // 言語切り替えスイッチを表示するか
    shouldShow() {
      return this.config.show;
    },
    // スイッチの左側の言語
    leftLang() {
      return this.config.leftLang;
    },
    // スイッチの右側の言語
    rightLang() {
      return this.config.rightLang;
    },
  },
  mounted() {
    // 初期表示時に指定された2言語のいずれかに設定されていない場合、左側の言語に設定
    if (
      this.currentLocale !== this.leftLang &&
      this.currentLocale !== this.rightLang
    ) {
      store.setLocale(this.leftLang);
    }
  },
  methods: {
    /**
     * 指定された地域に設定
     */
    setLocale(locale) {
      if (this.currentLocale !== locale) {
        store.setLocale(locale);
      }
    },
    /**
     * 地域コードからラベルを取得
     */
    getLocaleLabel(locale) {
      return this.languageLabels[locale] || locale;
    },
  },
};
</script>

<style scoped>
.language-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
}

.language-button {
  width: 36px;
  height: 24px;
  padding: 0 16px;
  border: 1px solid #333333;
  border-radius: 4px;
  box-shadow: 0 3px 6px #00000014;

  background: #ffffff;
  color: #333333;

  font-size: 12px;
  transition: all 0.3s ease;
  user-select: none;
  outline: none;

  display: flex;
  align-items: center;
  justify-content: center;
}

.language-button.active {
  background: #333333;
  color: #ffffff;
}
</style>
